'use client';

import Logo from '@/components/common/Logo';
import LoginForm from '@/components/common/LoginForm';
import { loginArtist } from '@/app/actions/artist/auth/login';

const ArtistLoginPageComponent = () => {
  return (
    <div className="min-h-screen bg-mono-10 flex flex-col items-center justify-start px-4 pt-24 pb-10 md:flex-row md:justify-center md:gap-[200px] md:px-[160px] md:py-0 md:items-center">
      {/* ロゴ（スマホでは上部、PCでは左側） */}
      <div className="flex-shrink-0 mb-16 md:mb-0">
        <div className="block md:hidden">
          <Logo size="lg" />
        </div>
        <div className="hidden md:block">
          <Logo size="xl" />
        </div>
      </div>

      {/* ログインフォーム（スマホでは下部、PCでは右側） */}
      <div className="flex-shrink-0 w-full md:w-auto">
        <LoginForm
          userType="artist"
          loginAction={loginArtist}
          signupLink="/artist/signup"
        />
      </div>
    </div>
  );
};

export default ArtistLoginPageComponent;
